import { render, staticRenderFns } from "./OffsetDialog.vue?vue&type=template&id=6ffa355e&"
import script from "./OffsetDialog.vue?vue&type=script&lang=js&"
export * from "./OffsetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports